var _excluded = ["playerName", "playerType"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

import autoBind from 'auto-bind';
import { ReplaySubject } from 'rxjs';
import { filter } from 'rxjs/operators';
import BTVimeoPlayer from './vimeo';
import BTWistiaPlayer from './wistia';
import { VIDEO_PLAYER_VIMEO, VIDEO_PLAYER_WISTIA, EVENT_PLAYER_CREATED } from './index';

var BTVideoPlayerManager = /*#__PURE__*/function () {
  function BTVideoPlayerManager() {
    _classCallCheck(this, BTVideoPlayerManager);

    autoBind(this);
    this._players = {};
    this._eventBus = new ReplaySubject();
  }

  _createClass(BTVideoPlayerManager, [{
    key: "getPlayer",
    value: function getPlayer(name) {
      return this._players[name];
    }
  }, {
    key: "subscribe",
    value: function subscribe(event, listener) {
      var eventSource = this._eventBus.pipe(filter(function (evt) {
        return evt.event === event;
      }));

      return eventSource.subscribe(listener);
    }
  }, {
    key: "createPlayer",
    value: function createPlayer(_ref) {
      var playerName = _ref.playerName,
          playerType = _ref.playerType,
          playerParams = _objectWithoutProperties(_ref, _excluded);

      if (!playerName) {
        throw new Error('playerName is required');
      }

      if (this._players[playerName]) {
        throw new Error("Player named '".concat(playerName, "' has already been created."));
      }

      switch (playerType) {
        case VIDEO_PLAYER_VIMEO:
          {
            var player = new BTVimeoPlayer(_objectSpread({
              name: playerName
            }, playerParams));

            this._onPlayerCreated(player);

            return player;
          }

        case VIDEO_PLAYER_WISTIA:
          {
            var _player = new BTWistiaPlayer(_objectSpread({
              name: playerName
            }, playerParams));

            this._onPlayerCreated(_player);

            return _player;
          }

        default:
          throw new Error("Invalid Player Type: ".concat(playerType));
      }
    }
  }, {
    key: "_onPlayerCreated",
    value: function _onPlayerCreated(player) {
      this._players[player.name] = player;

      this._eventBus.next({
        event: EVENT_PLAYER_CREATED,
        player: player
      });
    }
  }]);

  return BTVideoPlayerManager;
}();
/**
 * Gets the Video Player Manager instance.
 * @returns BTVideoPlayerManager
 */


export { BTVideoPlayerManager as default };
export function getVideoPlayerManager() {
  window.bt = window.bt || {};

  if (!window.bt.videoManager) {
    window.bt.videoManager = new BTVideoPlayerManager();
  }

  return window.bt.videoManager;
}